import {BaseView} from '../core/view';
import constants from '../utils/constants';
import { ApiUtil } from '../utils/api-util';
import { TrackingUtil } from '../utils/tracking';

export default BaseView.extend({

    el: '[data-bind=newsletter-signup]',

    events: {
        'submit': 'onSubmitHandlePreventDefault',
        'click .js-newsletter-signup': 'handleSignup',
        'focus input[type=email]': 'clearInputField'
    },

    initialize: function() {
    },

    onSubmitHandlePreventDefault: function(e) {
        e.preventDefault();
    },

    handleSignup: function(e) {
        var el = this.$el.find(e.currentTarget),
            wrapper = el.closest('[data-bind=newsletter-signup]'),
            email = $(wrapper).find('[data-bind=newsletter-email]').val(),
            location = $(wrapper).data('newsletter-location');

        this.submitNewsletterSignup(wrapper, email, location);
    },

    clearInputField: function(e) {
        this.$el.find(e.currentTarget).val('').removeClass('error');
    },

    submitNewsletterSignup: function(wrapper, email, location) {

        // test if values are set
        if (email !== undefined && jQuery.trim(email).length) {

            var emailRegex = constants.EMAIL_REGEX,
                that = this;

            // test if email is valid
            if (!emailRegex.test(email)) {

                if (location.indexOf('newsletter-') === 0) { // === 'newsletter-home-top') {
                    this.showErrorMessage(wrapper);
                }
            } else {
                wrapper.addClass('is-loading');
                ApiUtil.request({
                    path: constants.NEWSLETTER_SIGNUP_URL,
                    data: {
                        version: 1,
                        email: email
                    },
                    success: function() {
                        that.showSuccessMessage(wrapper, location);
                        TrackingUtil.throwNewsletterSignup(location);
                        wrapper.removeClass('is-loading');
                    },
                    error: function() {
                        wrapper.removeClass('is-loading');
                    }
                });

            }
        }
    },

    showSuccessMessage: function(wrapper, location) {

        if (location === 'newsletter-footer-bottom') {
            wrapper.find('[data-bind=newsletter-info]').remove();
            wrapper.find('[data-bind=newsletter-alert]').removeClass('hide').text(getI18N(jlocale.newsletterSuccess));
        } else {
            wrapper.find('input').hide();
            wrapper.find('button').hide();
            wrapper.find('.button').hide();
            wrapper.find(".success-message").removeClass("hidden");
        }
    },

    showErrorMessage: function(wrapper) {
        wrapper.find('input').addClass('error').val(jlocale.newsletterError);
    }
});
